import React from 'react';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { parseCurrencyTruncated } from '@upstart/harmony/lib/form-utils';
import { PriceInput } from '../../../../components/PencilEditor/Input';
import { SectionItem, SubsectionItem } from './FormItems';

interface PriceInputProps {
  title?: string;
  subtitle?: string;
  description?: React.ReactElement | null;
  field: string;
  value: number | undefined;
  onChange: (data: Partial<FinanceResponseData>) => void;
  required?: boolean;
}

interface BaseProps extends PriceInputProps {
  BaseItem: typeof SectionItem | typeof SubsectionItem;
}

export function BasePriceInputItem(props: BaseProps) {
  return (
    <props.BaseItem
      title={props.title}
      subtitle={props.subtitle}
      description={props.description}
      value={
        <PriceInput
          placeholder="N/A"
          value={props.value}
          required={props.required}
          onChange={val =>
            props.onChange({ [props.field]: parseCurrencyTruncated(val) })
          }
        />
      }
    />
  );
}

export function SectionInputItem(props: PriceInputProps) {
  return <BasePriceInputItem {...props} BaseItem={SectionItem} />;
}

export function SubsectionInputItem(props: PriceInputProps) {
  return <BasePriceInputItem {...props} BaseItem={SubsectionItem} />;
}
